<template>
  <v-app id="aps" v-if="profileLoaded">
    <router-view></router-view>
    <UserProfile ref="UserProfile" v-if="userProfile"></UserProfile>
    <Loading ref="Loading"></Loading>
    <SnackBar ref="SnackBar"></SnackBar>

  </v-app>
</template>

<script>


import { mapGetters } from "vuex";
import { setTimeout } from 'timers';
import AppConfig from "@/config/AppConfig";
import { bodyScript } from "@/common/helpers/helpers";
import SessionServices from '@/services/SessionServices'

export default {
  data() {
    return {
      profileLoaded: false,
    }
  },
  created() {

  },
  mounted() {
    
    let el = this;
    window.addEventListener("click", () => {
      if (localStorage.getItem("accessToken")) {
        el.checkToken();
      }
    });
    this.$root.$on("showSnackBar", (message, color) => {
      this.$refs.SnackBar.show(message, color);
    });
    this.$root.$on("showUserProfile", () => {
      this.$refs.UserProfile.show();
    });
    this.$root.$on("showLoading", message => {
      this.$refs.Loading.show(message);
    });
    this.$root.$on("hideLoading", () => {
      this.$refs.Loading.hide();
    });
    this.$store.dispatch("doSetUserProfile").then(() => {
      this.cambiaEstadoSucursal();
      this.profileLoaded = true;
    });
  },
  computed: {
    ...mapGetters(["userProfile"])
  },
  methods: {
    async cambiaEstadoSucursal() {
      console.log("cambiaEstadoSucursal called");

      try {
        // 👇 Espera a que el servicio responda antes de continuar
        const resp = await SessionServices.getValidaSucursal();

        // Procesar la respuesta
        let data = resp && resp.data ? resp.data : true;
        this.$global.validaSucursal =
        data === "true" ? true :
        data === "false" ? false :
        false; // valor por defecto

      } catch (err) {
        this.$global.validaSucursal = true; // Valor por defecto en caso de error
      }

      // Si necesitas usar el valor después:
      console.log("➡️ Valor final:", this.$global.validaSucursal);
    },
    checkToken() {
      let currentDate = new Date();
      let credentialsUser = {
        grant_type: "refresh_token",
        refresh_token: localStorage.getItem("refreshToken"),
        client_id: "5c33d309cc761c4d05397c6d",
        client_secret:
          "65051e36023fa92764bcf351b3cb685d82e0daf802e77cff0fe493698313e1ee"
      };
      if (
        localStorage.getItem("expirationTime") - currentDate.getTime() >= 0 &&
        localStorage.getItem("expirationTime") - currentDate.getTime() <= 120000
      ) {
        this.$store.dispatch("generateToken", credentialsUser).then(res => {
          //console.log(res.data);
          if (res.data.code == 200) {
            const data = res.data.data;

            localStorage.setItem("accessToken", data.accessToken);

            let expirationTime = new Date(data.accessTokenExpiresAt);
            let expirationRefreshTime = new Date(
              res.data.data.refreshTokenExpiresAt
            );
            localStorage.setItem(
              "expirationRefreshTime",
              expirationRefreshTime.getTime()
            );

            localStorage.setItem("expirationTime", expirationTime.getTime());
            localStorage.setItem("refreshToken", data.refreshToken);

          } else {
            localStorage.clear();
            this.$store.dispatch("logoutUser");
            this.$router.push("/session/login");
            location.reload();
          }
        });
        return;
      }
      if (localStorage.getItem("expirationTime") - currentDate.getTime() < 0) {
        if (
          localStorage.getItem("expirationRefreshTime") > currentDate.getTime()
        ) {
          this.$store.dispatch("generateToken", credentialsUser).then(res => {
            //console.log(res.data);
            if (res.data.code == 200) {
              const data = res.data.data;

              localStorage.setItem("accessToken", data.accessToken);

              let expirationTime = new Date(data.accessTokenExpiresAt);
              let expirationRefreshTime = new Date(
                res.data.data.refreshTokenExpiresAt
              );
              localStorage.setItem(
                "expirationRefreshTime",
                expirationRefreshTime.getTime()
              );

              localStorage.setItem("expirationTime", expirationTime.getTime());
              localStorage.setItem("refreshToken", data.refreshToken);

            } else {
              localStorage.clear();
              this.$store.dispatch("logoutUser");
              this.$router.push("/session/login");
              location.reload();
            }
          });
        } else {
          localStorage.clear();
          this.$store.dispatch("logoutUser");
          this.$router.push("/session/login");
          location.reload();
        }

        return;
      }
    },
  }
};
</script>


<style>
.v-input--has-state.error--text .v-label {
  -webkit-animation: none !important;
  animation: none !important;
}
</style>
